import React, { useState } from 'react';
import Sidebar from './Sidebar';
import TopNavbar from '../top-navbar/TopNav';
import '../../styles/employee/Employment-check-Virtual.css';
import { toast, ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { vitualVerificationMail } from '../../services/employee/api';

function EmploymentCheckVirtual({ candidateId, candidateName, candidateEmail, hrContactStatuses, onBack }) {
  const [selectedIndex, setSelectedIndex] = useState(0);
  const [loading, setLoading] = useState(false);

  const candidateData = {
    name: candidateName || 'N/A',
    email: candidateEmail || 'N/A'
  };

  const handleCancel = () => {
    onBack();
  };

  const formatDate = (isoString) => {
    if (!isoString) return 'N/A';
    const date = new Date(isoString);
    return date.toLocaleDateString('en-GB');
  };

  const handleSendEmail = async () => {
    const selectedHR = hrContactStatuses[selectedIndex];
    if (!selectedHR) {
      toast.warn("No HR contact selected.");
      return;
    }

    const payload = {
      candidateId,
      hrContactEmail: selectedHR.hrContactEmail,
      hrContactNumber: selectedHR.hrContactNumber || ""
    };

    try {
      setLoading(true);
      const response = await vitualVerificationMail(payload);

      const successMessage =
        response?.data?.message ||
        `Verification email sent successfully to ${selectedHR.hrContactEmail}!`;

      toast.success(successMessage, {
        position: "top-right",
        autoClose: 2000
      });

      // Brief delay so the user can see the toast before returning to the dashboard
      setTimeout(() => {
        onBack();
      }, 1200);

    } catch (error) {
      const errorMessage =
        error.response?.data?.message ||
        error.message ||
        "Failed to send email to HR";

      toast.error(errorMessage, {
        position: "top-right",
        autoClose: 3000
      });
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="dashboard-app-container">
      <ToastContainer />
      <Sidebar />
      <div className="dashboard-right-panel">
        <TopNavbar />
        <header className="employee-virtual-header">
          <h1 className="employee-virtual-title">Virtual Verification</h1>
        </header>
        <div className="employee-virtual-virtual-verification-container">
    

          <div className="employee-virtual-content-area">
            <div className="employee-virtual-section-title">
              Company HR Contact Status
              <div className="employee-virtual-section-title-line"></div>
            </div>

            <div className="employee-virtual-candidate-details">
              <div className="employee-virtual-input-group">
                <label className="employee-virtual-input-label">Candidate Name</label>
                <input type="text" value={candidateData.name} readOnly className="employee-virtual-input-field" />
              </div>
              <div className="employee-virtual-input-group">
                <label className="employee-virtual-input-label">Candidate Email</label>
                <input type="text" value={candidateData.email} readOnly className="employee-virtual-input-field" />
              </div>
            </div>

            <div className="employee-virtual-hr-contacts-list">
              {hrContactStatuses?.length > 0 ? (
                hrContactStatuses.map((hr, index) => (
                  <label key={index} className="employee-virtual-hr-contact-item">
                    <input
                      type="radio"
                      name="hrContact"
                      className="employee-virtual-custom-radio"
                      checked={selectedIndex === index}
                      onChange={() => setSelectedIndex(index)}
                    />
                    <div className="employee-virtual-hr-contact-details">
                      <div className="employee-virtual-hr-detail-column">
                        <span className="employee-virtual-hr-detail-label">Company Name</span>
                        <span className="employee-virtual-hr-detail-value">{hr.companyName || 'N/A'}</span>
                      </div>
                      <div className="employee-virtual-hr-detail-column">
                        <span className="employee-virtual-hr-detail-label">HR Contact Email</span>
                        <span className="employee-virtual-hr-detail-value">{hr.hrContactEmail || 'N/A'}</span>
                      </div>
                      <div className="employee-virtual-hr-detail-column">
                        <span className="employee-virtual-hr-detail-label">Mail Triggered</span>
                        <span className="employee-virtual-hr-detail-value">{hr.emailCount ?? 0}</span>
                      </div>
                      <div className="employee-virtual-hr-detail-column">
                        <span className="employee-virtual-hr-detail-label">Last Sent On</span>
                        <span className="employee-virtual-hr-detail-value">{formatDate(hr.lastSentTime)}</span>
                      </div>
                    </div>
                  </label>
                ))
              ) : (
                <p>No HR contact status found.</p>
              )}
            </div>

            <div className="employee-virtual-action-buttons">
              <button onClick={handleCancel} className="employee-virtual-cancel-button" disabled={loading}>Cancel</button>
              <button
                type="button"
                className="employee-virtual-send-email-button"
                onClick={handleSendEmail}
                disabled={loading}
              >
                {loading ? 'Sending...' : 'Send Email'}
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none"
                  xmlns="http://www.w3.org/2000/svg">
                  <path d="M10 6L8.59 7.41L13.17 12L8.59 16.59L10 18L16 12L10 6Z" fill="white" />
                </svg>
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default EmploymentCheckVirtual;
